module.exports = __webpack_public_path__ + "img/nasil_mersis.0090aef6.svg";